import React from 'react';

import Alert from '@mui/material/Alert';
import { WidgetsMapComponentKeys } from 'config/widgetConfigurations/widgetsConfigurations';

import { useQueryGetComponentsLibrary } from 'api/queries/getComponentsLibrary.query';

import classes from 'components/common/WidgetExistInBackend/WidgetExistInBackend.module.scss';

interface Props extends React.PropsWithChildren {
    componentKey: WidgetsMapComponentKeys;
}

export const WidgetExistInBackend = ({ componentKey, children }: Props) => {
    const { data: widgets, isFetching } = useQueryGetComponentsLibrary();

    const componentKeys = widgets?.map((item) => item.componentKey);

    const componentKeyExistsInBackend = componentKeys ? componentKeys.includes(componentKey) : false;

    const isProduction = process.env.NODE_ENV === 'production';

    // in production - skip validation
    if (isProduction || isFetching) return <>{children}</>;

    // in development - perform validate key exist in backend list of widgets
    return componentKeyExistsInBackend ? (
        <>{children}</>
    ) : (
        <div className={classes.container}>
            <Alert severity={'error'} className={classes.alert}>
                component key <strong>{componentKey}</strong> not exist in getComponentsLibrary API.
            </Alert>
        </div>
    );
};
